import React, { useEffect, useState } from 'react';
import { getMarkDown, formatCardLoadTiming, getButtonWithArrow, useNextButtonWidthClass } from '../utils';
import Footer from './Footer';
import TextField from '@mui/material/TextField';
import '../../../stylesheets/triagebot/FreeTextField.scss';
import { datadogRum } from '@datadog/browser-rum';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';

const FreeTextField = ({ message, sendMessage, disabled }) => {
    const [input, setInput] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const MAX_CHAR = 500;
    const nextButtonClass = useNextButtonWidthClass();

    const inputChanged = (e) => {
        setCharacterCount(e.target.value.length)
        setInput(e.target.value);
    }

    const isDisabled = submitted || disabled;
    const cardName = (message.data && message.data[0] && message.data[0].question_id)
        ? message.data[0].question_id
        : "FreeTextSymptoms";

    const submitPress = (event, button) => {
        if (submitted) return;

        setSubmitted(true);
        if (input === "")
            sendMessage('message', "N/A", "N/A", cardName)
        else
            sendMessage('message', input, input, cardName)
        datadogRum.addAction("anythingElseMessage-"+input)
    }

    const headerText = (message.data && message.data.length && message.data[0].headerText)
        ? message.data[0].headerText
        : ''

    const subHeaderText = (message.data && message.data.length && message.data[0].subHeaderText)
        ? message.data[0].subHeaderText
        : ''
        
    const nextButton =(message.buttons?.[0].displayText)
    ? message.buttons?.[0].displayText
    : ''

    useEffect(()=>{
        var textfield = document.querySelector('div.freetextfield.card textarea');
        setTimeout(() => {
            textfield?.focus();
        }, 500); 
    }, []);

    const { logTiming } = useTiming();
    useCardLoadTiming({
                sentAt: message._sentAt,
                cardName,
                logTiming,
                formatCardLoadTiming
            });

    return (
        <div className={isDisabled?'disabled freetextfield card':'freetextfield card'}>
            <div className='content'>
                <div className='header headerTextColor'>
                    <h2 id='freetextfield-header' className='headerText' tabIndex={isDisabled?"-1":"0"}>{getMarkDown(headerText)}</h2>
                </div>
                <div className='subHeader'>
                    {getMarkDown(subHeaderText)}
                </div>
                <div className='body'>
                    <TextField
                        className='comment'
                        variant="outlined"
                        aria-invalid="false"
                        multiline
                        minRows={4}
                        maxRows={4}
                        value={input}
                        onChange={inputChanged}
                        inputProps={{ maxLength: 500, style: { 'marginBottom': 15 }, 'aria-labelledby': 'freetextfield-header' }}
                        disabled={isDisabled}
                    />
                </div>
                <div className={(characterCount) ? 'counter' : 'ghosted counter'} >
                    {MAX_CHAR - characterCount}
                </div>
            </div >
            <Footer>
                {
                    submitted ||
                    <button
                        className={`submit-button ${nextButtonClass}`.trim()}
                        onClick={submitPress}
                        disabled={disabled}
                    >
                        {getButtonWithArrow(nextButton)}
                        </button>
                }
            </Footer>

        </div >
    );
}

export default FreeTextField;